import React from 'react';
import { Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PLATFORM_FEE_TYPE } from 'constants';
import { SERVICE_FEE_TYPE } from 'constants';

export const visibleColumnIds = [
  'name',
  'status',
  'stripe_connect_enabled',
  'state',
  'country',
  'platform_fee',
  'group_comm',
  'service_fee_default_amount',
  'driver_numbers'
];

export const availableColumns = [
  'name',
  'status',
  'stripe_connect_enabled',
  'state',
  'country',
  'platform_fee_type',
  'platform_fee',
  'service_fee_type',
  'service_fee_default_amount',
  'group_comm',
  'driver_numbers'
];

// All columns
export const columnsConfig = [
  {
    accessor: 'name',
    Header: 'Name',
    width: 180,
    headerProps: { className: 'text-900' },
    cellProps: {
      className: 'py-2'
    }
  },
  {
    accessor: 'status',
    Header: 'Status',
    width: 100,
    headerProps: { className: 'text-900 text-center' },
    cellProps: {
      className: 'justify-content-center'
    },
    Cell: rowData => {
      const { status } = rowData.row.original;
      return (
        <Badge bg={status === 1 ? 'success' : 'danger'} className="badge-min-w">
          {status === 1 ? 'Active' : 'Inactive'}
          <FontAwesomeIcon icon="check" className="ms-1" transform="shrink-2" />
        </Badge>
      );
    }
  },
  {
    accessor: 'stripe_connect_enabled',
    Header: 'Stripe Connect',
    width: 100,
    headerProps: { className: 'text-900 text-center' },
    cellProps: {
      className: 'justify-content-center'
    },
    Cell: rowData => {
      const { stripe_connect_enabled: item } = rowData.row.original;
      return (
        <Badge bg={item === 1 ? 'success' : 'danger'} className="badge-min-w">
          {item === 1 ? 'Yes' : 'No'}
          <FontAwesomeIcon icon="check" className="ms-1" transform="shrink-2" />
        </Badge>
      );
    }
  },
  {
    accessor: 'state',
    Header: 'State',
    width: 200,
    headerProps: { className: 'text-900' },
    cellProps: {
      className: 'text-start'
    }
  },
  {
    accessor: 'country',
    Header: 'Country',
    width: 100,
    headerProps: { className: 'text-900' },
    cellProps: { className: 'text-start' }
  },
  {
    accessor: 'platform_fee_type',
    Header: 'Platform Fee Type',
    width: 120,
    headerProps: { className: 'text-900 text-start' },
    Cell: rowData => {
      const { platform_fee_type: type } = rowData.row.original;
      return <span>{PLATFORM_FEE_TYPE.find(item => item.value === type)?.label}</span>;
    }
  },
  {
    accessor: 'platform_fee',
    Header: 'Platform Fee',
    width: 100,
    headerProps: { className: 'text-900 text-end' },
    cellProps: {
      className: 'justify-content-end'
    },
    Cell: rowData => {
      const { platform_fee: platformFee, platform_fee_type: platformFeeType } =
        rowData.row.original;
      if (platformFeeType === PLATFORM_FEE_TYPE[0].value) {
        return <span>{platformFee}%</span>;
      }
      return <span>${platformFee} </span>;
    }
  },
  {
    accessor: 'service_fee_type',
    Header: 'Service Fee Type',
    width: 120,
    headerProps: { className: 'text-900 text-start' },
    cellProps: {
      className: ''
    },
    Cell: rowData => {
      const { service_fee_type: type } = rowData.row.original;
      return <span>{SERVICE_FEE_TYPE.find(item => item.value === type)?.label}</span>;
    }
  },
  {
    accessor: 'service_fee_default_amount',
    Header: 'Service Fee',
    width: 80,
    headerProps: { className: 'text-900 text-end' },
    cellProps: {
      className: 'justify-content-end'
    },
    Cell: rowData => {
      const { service_fee: serviceFee, service_fee_type: serviceFeeType } = rowData.row.original;
      if (serviceFeeType === SERVICE_FEE_TYPE[0].value) {
        return <span>{serviceFee}%</span>;
      }
      return <span>${serviceFee} </span>;
    }
  },
  {
    accessor: 'group_comm',
    Header: 'Group Rate (inc Tax)',
    headerProps: { className: 'text-900 text-end' },
    cellProps: {
      className: 'justify-content-end',
      width: 150
    },
    Cell: rowData => {
      const { group_comm: groupComm } = rowData.row.original;
      return <span>{groupComm}%</span>;
    }
  },
  {
    accessor: 'driver_numbers',
    Header: 'Drivers',
    width: 80,
    headerProps: { className: 'text-900 text-end' },
    cellProps: {
      className: 'justify-content-end'
    }
  }
];
